<template>
  <div class="tuolele-main-box payment-alipay">
    <el-form ref="form" :model="alipayInfo" label-width="120px">
      <!-- <el-form-item label="支付宝联通状态">
        <span class="color-blue">已联通</span>
      </el-form-item> -->
      <el-form-item label="APP ID">
        <el-input v-model="alipayInfo.appid" clearable />
      </el-form-item>
      <el-form-item label="商户私钥">
        <el-input
          v-model="alipayInfo.private_key"
          type="textarea"
          resize="none"
          :autosize="{ minRows: 10 }"
        />
      </el-form-item>
      <el-form-item label="支付宝公钥">
        <el-input
          v-model="alipayInfo.alipay_public_key"
          type="textarea"
          resize="none"
          :autosize="{ minRows: 10 }"
        />
      </el-form-item>
      <el-form-item class="form-buttom">
        <el-button
          type="primary"
          class="el-button-confirm"
          @click="alipaySet"
        >保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'PaymentAlipay',
  components: {},
  data() {
    return {
      alipayInfo: {
        appid: '',
        private_key: '',
        alipay_public_key: ''
      }
    }
  },
  mounted() {
    this.getAlipayInfo()
  },
  methods: {
    getAlipayInfo() {
      this.$http.getAlipayInfo().then(res => {
        this.alipayInfo = res.data
      })
    },
    alipaySet() {
      // for (const key in this.alipayInfo) {
      //   if (this.alipayInfo[key] == "") {
      //     this.$message({
      //       type: "info",
      //       message: "请完善支付宝配置信息"
      //     });
      //     return;
      //   }
      // }
      this.$http.alipaySet(this.alipayInfo).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '支付宝设置成功'
          })
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>
<style lang="scss">
.payment-alipay {
  .el-input {
    width: 310px !important;
  }
  .el-textarea {
    width: 700px !important;
  }
  .form-buttom {
    .el-form-item__content {
      margin-left: 135px !important;
    }
  }
}
</style>
